import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBF9F4] px-4">
      <div
        data-testid="payment-cancel-page"
        className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-xl shadow-blue-900/5"
      >
        <XCircle className="mx-auto h-12 w-12 text-slate-400" />
        <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">Checkout canceled</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          No charge was made. Whenever you're ready, the Do-It-Yourself System and One-on-One
          Coaching will be waiting for you.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home-link"
          className="mt-8 inline-flex items-center justify-center rounded-xl bg-blue-700 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-blue-800"
        >
          Back to nowlifeworks.com
        </Link>
      </div>
    </div>
  );
}
